import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@abodeminehq/parcel-ui/icons/fa/pro-solid";
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'
import { AppNavigation } from '~/components/app/shared/navigation/app-navigation'
import { useAuthContext } from '~/contexts/auth-context'
import { useHasActiveOrg } from '~/hooks/use-has-active-org'
import { ContentUnavailableView } from '~/components/layouts/ContentUnavailableView'
export const Route = createFileRoute('/docs')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuthContext()
  const { hasActiveOrg, isLoading: isOrgLoading } = useHasActiveOrg()
  
  const isLoading = isAuthLoading || isOrgLoading

  useEffect(() => {
    if (!isAuthLoading && !isAuthenticated && typeof window !== 'undefined') {
      window.location.href = '/'
    }
  }, [isAuthLoading, isAuthenticated])
  
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return null
  }

  if (!hasActiveOrg && !isOrgLoading) {
    return (
      <div className="flex h-screen flex-col">
        <AppNavigation />
        <main className="flex-1 overflow-auto flex items-center justify-center">
          <ContentUnavailableView
            title="No Active Organizations"
            description="You must be part of an active organization to access documentation. Please contact your organization administrator."
            icon={faBuilding}
          />
        </main>
      </div>
    )
  }

  return (
    <div className="flex h-screen flex-col">
      <AppNavigation />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}
